module.exports = __webpack_public_path__ + "img/mosque.871f8fb7.svg";